var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"by-effect"},[_c('div',{staticClass:"by-effect-wrapper"},[_c('div',{staticClass:"image"},[_vm._t("header")],2),_c('div',{staticClass:"content"},[_vm._t("content")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }